import script from "./CompanionMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionMap.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionMap.vue?vue&type=style&index=0&id=a3559f3c&lang=stylus&scoped=true"
import "./CompanionMap.vue?vue&type=style&index=1&id=a3559f3c&lang=stylus"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3559f3c"]])

export default __exports__